export default __webpack_public_path__ + "static/media/Microsoft-Stream_128x128.412cf498.webp";